import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const ListOfTaskPage = () => {
  return(
    <HomeUI />
  )
}

export default ListOfTaskPage;
